import React from "react";
import { Button } from "antd";
import notebook from "./files/notebook.png";
import styles from "./main.module.css";

class MainSlide extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className={styles.container}>
        <div
          className={styles.slideImgWrapper}
          style={{
            backgroundImage: "url(" + notebook + ")",
            backgroundColor: "transparent",
            backgroundPosition: "74%"
          }}
        >
          <img
            src={notebook}
            alt="slide 0"
            style={{
              width: "100%",
              height: "100%"
            }}
            className={styles.slideimg}
          />
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <div style={{ flex: "3" }}>
            <div
              style={{
                alignSelf: "flex-start",
                paddingLeft: "12%"
              }}
            >
              <div style={{ fontWeight: "600" }}>
                ИНТЕРНЕТ-СЛУЖБА «ТЕПЛОИНФОРМ» — ЭТО АВТОМАТИЗИРОВАННАЯ
              </div>

              <div style={{ fontWeight: "600" }}>
                ИНФОРМАЦИОННАЯ СИСТЕМА, ОБЕСПЕЧИВАЮЩАЯ:
              </div>
              <div style={{ fontWeight: "initial" }}>
                <ul className="globalUlList">
                  <li
                    style={{
                      display: "list-item"
                    }}
                  >
                    Автоматический сбор данных с узлов учёта установленных абонентов МОЭК и других сбытовых компаний
                  </li>
                  <li style={{ display: "list-item" }}>
                    Формирование ведомостей в формате html-МОЭК
                  </li>
                  <li style={{ display: "list-item" }}>
                    Контроль нештатных ситуаций
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div style={{ flex: "1", textAlign: "center" }}>
            <Button
              onClick={this.props.demoEnter}
              type="primary"
              size="large"
              style={{
                borderRadius: "25px",
                backgroundColor: "#2679BD",
                fontSize: "inherit",
                height: "2.5vw",
                width: "12vw"
              }}
            >
              ПОПРОБОВАТЬ
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default MainSlide;
